const middleware = {}

middleware['authorize'] = require('..\\middleware\\authorize.js')
middleware['authorize'] = middleware['authorize'].default || middleware['authorize']

middleware['kiosk'] = require('..\\middleware\\kiosk.js')
middleware['kiosk'] = middleware['kiosk'].default || middleware['kiosk']

export default middleware
